<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-5-tablet is-4-desktop is-3-widescreen">
            <div v-if="errorMessage" class="notification is-danger">
              {{ errorMessage }}
            </div>
            <form action="" class="box">
              <div class="field has-text-centered mb-5">
                <h1 class="title">OCA Login</h1>
              </div>
              <div class="field has-text-centered">
                <button type="button" class="button is-borderless" @click="loginWithMicrosoft">
                  <img src="@/assets/ms-symbollockup_signin_dark.svg">
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useAuthStore } from '@/store';

export default {
  name: 'LoginForm',
  setup() {
    const errorMessage = ref('');

    onMounted(() => {
      // Check for error messages passed from router navigation
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('result') === 'failure') {
        try {
          const errorObj = JSON.parse(decodeURIComponent(urlParams.get('error')));
          errorMessage.value = errorObj.message;
        } catch (e) {
          errorMessage.value = 'Authentication failed. Please try again.';
        }
      }
    });

    async function loginWithMicrosoft() {
      try {
        errorMessage.value = ''; // Clear any previous errors
        await useAuthStore().login();
      } catch (error) {
        errorMessage.value = 'Failed to initiate login. Please try again.';
        console.error('Login error:', error);
      }
    }

    return {
      errorMessage,
      loginWithMicrosoft
    };
  }
};
</script>